import { Component, Input, OnInit } from '@angular/core';
import { CustomMessageBannerInfo } from '@app/home/models/custom-message-banner-info.model';
import { PlatformService } from '@panamax/app-state';
import { NavigationHelperService } from '@shared/helpers/navigation.helpers.service';

@Component({
  selector: 'app-custom-message-banner',
  templateUrl: './custom-message-banner.component.html',
  styleUrls: ['./custom-message-banner.component.scss'],
})
export class CustomMessageBannerComponent implements OnInit {
  @Input() customMessageBannerInfo?: CustomMessageBannerInfo;
  croppedText: string;

  constructor(
    readonly navigationHelperService: NavigationHelperService,
    readonly platformService: PlatformService,
  ) {}

  ngOnInit(): void {
    this.croppedText = this.customMessageBannerInfo?.text?.slice(0, 90);
  }

  onClickCustomMessage(): void {
    this.navigationHelperService.openDocumentInTabBrowser(
      this.customMessageBannerInfo?.link,
    );
  }
}
